import React, { Component } from 'react';

import ProfilePicture from '../../components/shared/ProfilePicture';
import data from '../../../json/data.json';

// eslint-disable-next-line
class About extends Component {
  render() {
    return (
      <section className="about">
        <div className="container">
          <ProfilePicture />
          <h4 id="rluijten" className="about__title section__title"><span className="underline">#rluijten</span></h4>
          <p className="about__text">
            {data[0].about.description.part1}
            <span className="strikethrough">{data[0].about.description.part2}</span>
            &nbsp;<span className="underline">{data[0].about.description.part3}</span>
            {data[0].about.description.part4}
          </p>

          <h4 className="section__title">#clients</h4>
          <p className="about__text">
            <a href="https://a24films.com/" target="_blank" rel="noopener noreferrer"> <span className="underline">A24</span></a>,
            <a href="https://www.accenture.com/" target="_blank" rel="noopener noreferrer"> <span className="underline">Accenture</span></a>,
            <a href="https://www.amazon.com/" target="_blank" rel="noopener noreferrer"> <span className="underline">Amazon</span></a>,
            <a href="https://www.apple.com/" target="_blank" rel="noopener noreferrer"> <span className="underline">Apple</span></a>,
            <a href="https://www.bmwusa.com/" target="_blank" rel="noopener noreferrer"> <span className="underline">BMW</span></a>,
            <a href="https://www.columbiapictures.com/" target="_blank" rel="noopener noreferrer"> <span className="underline">Columbia Pictures</span></a>,
            <a href="https://www.coors.com/" target="_blank" rel="noopener noreferrer"> <span className="underline">Coors</span></a>,
            <a href="https://www.disneyplus.com/" target="_blank" rel="noopener noreferrer"> <span className="underline">Disney+</span></a>,
            <a href="https://www.espn.com/" target="_blank" rel="noopener noreferrer"> <span className="underline">ESPN</span></a>,
            <a href="https://www.ge.com/" target="_blank" rel="noopener noreferrer"> <span className="underline">General Electric</span></a>,
            <a href="https://www.hulu.com/" target="_blank" rel="noopener noreferrer"> <span className="underline">Hulu</span></a>,
            <a href="https://www.mammut.com/" target="_blank" rel="noopener noreferrer"> <span className="underline">Mammut</span></a>,
            <a href="https://www.sonypictures.com/" target="_blank" rel="noopener noreferrer"> <span className="underline">Sony</span></a>,
            <a href="https://www.spotify.com/" target="_blank" rel="noopener noreferrer"> <span className="underline">Spotify</span></a>
          </p>

          <h4 className="section__title">#sayHello</h4>
          <p className="about__text">
            <a href="mailto:ruud@rlly.co">ruud@rlly.co</a><br />
          </p>
        </div>
      </section>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./client/js/components/about/About.js